import pako from 'pako'

import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { mapMarketYoyGrowthPlanningDataFromApi } from '../lib'
import { IMarketYoyGrowthPlanningData } from '../model/types'

import { IMarketYoyGrowthExpectationApi, IMarketYoyGrowthPlanningResponse } from './types'

interface IFetchMarketYoyGrowthExpectations {
  fYear: number
}

export const fetchMarketYoyGrowthExpectations = async ({
  fYear,
}: IFetchMarketYoyGrowthExpectations): Promise<IMarketYoyGrowthPlanningData> => {
  const response = await callProcedure<IProcedureResponse<IMarketYoyGrowthExpectationApi[]>>({
    url: '/webservice/621/sp/v4/spJBPYoYGrowthPlanningGzip/call',
    method: 'POST',
    data: {
      'p.FYear': fYear,
    },
  })

  if ('error' in response) {
    throw response.error
  }

  const apiData = response.data.Data ?? []
  if (apiData.length) {
    // @ts-ignore
    const base64Gzip = apiData[0].result as string
    const string = atob(base64Gzip)
    const charData = string.split('').map(function (x) {
      return x.charCodeAt(0)
    })
    const binData = new Uint8Array(charData)
    const result = pako.ungzip(binData, { to: 'string' })
    const apiResponse: IMarketYoyGrowthPlanningResponse = JSON.parse(result)
    return mapMarketYoyGrowthPlanningDataFromApi(apiResponse.data)
  }

  return {
    planningDetails: [],
    planning: {
      entryId: -1,
      uid: '',
      created: '',
      createdBy: '',
      modified: '',
      modifiedBy: '',
      fYear: -1,
      status: 'Draft',
      isLocked: true,
    },
    userInfo: {
      market: '',
      userId: '',
      viewType: 'Market',
    },
    geoMarkets: [],
    categories: [],
    log: [],
  }
}
